import reportError from 'airship/modules/report-error'

import type {AsyncValidationHandler, ValidationHandler} from './types'
import {ValidationError, ValidationWarning} from './types'

export function validate<T>(
  validators: ValidationHandler<T>[],
  value?: T
): [ValidationError[], ValidationWarning[]] {
  const errors: ValidationError[] = []
  const warnings: ValidationWarning[] = []

  for (const validator of validators) {
    try {
      validator(value)
    } catch (e) {
      if (!(e instanceof ValidationError || e instanceof ValidationWarning)) {
        reportError(e)
        throw e
      }

      if (e instanceof ValidationWarning) {
        warnings.push(e)
      }

      if (e instanceof ValidationError) {
        errors.push(e)
      }
    }
  }
  return [errors, warnings]
}

export async function asyncValidate<T>(
  validators: AsyncValidationHandler<T>[],
  value?: T
): Promise<[ValidationError[], ValidationWarning[]]> {
  const errors: ValidationError[] = []
  const warnings: ValidationWarning[] = []
  try {
    await Promise.all(validators.map((v) => v(value)))
  } catch (e) {
    // TODO (TPS-148): Handle synchronous runtime errors
    if (!(e instanceof ValidationError || e instanceof ValidationWarning)) {
      reportError(e)
      throw e
    }

    if (e instanceof ValidationWarning) {
      warnings.push(e)
    }

    if (e instanceof ValidationError) {
      errors.push(e)
    }
  }
  return [errors, warnings]
}
